<app-loader [showLoader]="showLoading" [textColor]="'rgba(4, 108, 235, 1)'" [loadingText]="loadingText"></app-loader>
<router-outlet>
</router-outlet>
